import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import { Image } from '@/app/components/media/image';
import type { ContentBlockProps } from '@/app/components/sections/service/service-center/image-with-cta/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const ContentBlock = t0 => {
  const $ = _c(18);
  const {
    title,
    logo,
    buttons: t1,
    theme: t2,
    layout: t3,
    titleClassName,
    logoClassName,
    tracking
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const buttons = t4;
  const theme = t2 === undefined ? "dark" : t2;
  const layout = t3 === undefined ? "grid" : t3;
  const isFull = layout === "full";
  let t5;
  if ($[2] !== isFull || $[3] !== logo || $[4] !== logoClassName) {
    t5 = !!logo?.src && <Image className={cn({
      "order-1": isFull,
      "order-2": !isFull
    }, logoClassName)} src={logo.src} alt={logo.alt || ""} width={logo.width} height={logo.height} aspectRatio="calculate" sizes="216px" attributes={createDataAttributes({
      revealanim: "true"
    })} />;
    $[2] = isFull;
    $[3] = logo;
    $[4] = logoClassName;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isFull || $[7] !== theme || $[8] !== title || $[9] !== titleClassName) {
    t6 = !!title && <h2 className={cn(titleClassName, {
      "text-white": theme === "dark",
      "order-2": isFull,
      "order-1": !isFull
    })} data-revealanim={true} {...createDataAttributes({
      test: "title"
    })} dangerouslySetInnerHTML={{
      __html: title
    }} />;
    $[6] = isFull;
    $[7] = theme;
    $[8] = title;
    $[9] = titleClassName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== buttons || $[12] !== tracking) {
    t7 = buttons.length > 0 && <ButtonGroup className="order-3 mt-6" {...createDataAttributes({
      test: "buttons"
    })} data-revealanim={true}>{buttons.map((button, index) => <Button key={index} {...button} width="min" {...createDataAttributes({
        test: `button-${index + 1}`
      })} {...createDataGA({
        click: true,
        url: button.href,
        text: button.children,
        ...tracking
      })}>{button.children}</Button>)}</ButtonGroup>;
    $[11] = buttons;
    $[12] = tracking;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="grid grid-cols-1 place-items-center gap-y-4">{t5}{t6}{t7}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};